<template>
  <div class="products" id="products">
    <div class="container">
      <h1 class="section-title pt-5">Nuestras líneas de iluminación</h1>
      <div class="productslist">
        <div class="productslist-center">
          <div v-for="categoria in categorias">
            <div class="product">
              <div class="img-container">
                <img :src="categoria.images[0]" alt />
                <div class="price-top">
                  <h6 class>{{ categoria.name }}</h6>
                </div>
                <router-link
                  :to="{ name: 'productos', params: { dato:categoria.name } }"
                  class="btn-primary product-link"
                >ver productos</router-link>
              </div>

              <!-- <div class="product-info">
                          
                          <div class="">
                            <h5 class="card-title">{{ categoria.description.slice(3, -4) }}</h5>                                                       
                             
                            
                            

                          </div>
                           
                            
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <mini-cart></mini-cart>
  </div>
</template>

<script>
import { db } from "../firebase";

export default {
  name: "Line-list",
  props: {
    msg: String
  },

  data() {
    return {
      categorias: []
    };
  },

  methods: {
    getImage(images) {
      return images[0];
    },
    getTag(tags) {
      return tags[0];
    }
  },

  firestore() {
    return {
      categorias: db.collection("categorias")
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.products {
  margin-top: 1rem;
  background: #ffffff;
  padding-bottom: 3rem;
}
.productslist {
  padding: 5rem 0;
}
.productslist-center {
  width: 80vw;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 2rem;
}

@media screen and (min-width: 776px) {
  .productslist-center {
    width: 90vw;
  }
}
@media screen and (min-width: 992px) {
  .productslist-center {
    width: 95vw;
  }
}

/* product */
.product {
  box-shadow: var(--lightShadow);
  transition: var(--mainTransition);
}
.product:hover {
  box-shadow: var(--darkShadow);
}

.img-container {
  position: relative;
}
.img-container img {
  width: 100%;
  display: block;
  transition: var(--mainTransition);
}
.price-top {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  color: var(--mainWhite);
  padding: 0.3rem 0.6rem 0.5rem;
  border-bottom-right-radius: 1rem;
  font-size: 0.7rem;
  text-align: center;
  transition: var(--mainTransition);
}
.price-top h6 {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: var(--mainSpacing);
}
.product-link {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: scale(0);
  transition: all 0.3s linear;
}
.img-container:hover {
  background: rgba(0, 0, 0, 0.8);
}
.img-container:hover img {
  opacity: 0.3;
}
.img-container:hover .price-top {
  opacity: 0;
}
.img-container:hover .product-link {
  transform: translate(-50%, -50%) scale(1);
}
.product-info {
  background: var(--darkGrey);
  text-transform: capitalize;
  padding: 0.5rem 0;
  text-align: center;
  font-weight: 700;

  letter-spacing: var(--mainSpacing);
}
/* end of product  */

.section-title {
  text-align: center;
  margin-bottom: 4rem;
}
.section-title h4 {
  font-size: 2rem;
  letter-spacing: var(--mainSpacing);
  text-transform: capitalize;
  margin-bottom: 1rem;
}
.section-title div {
  width: 18rem;
  height: 5px;
  margin: 0 auto;
  background: var(--primaryColor);
}
</style>
